<script>
import { mapGetters } from 'vuex';
import api from '../api';

export default {
    mounted() {
        if (this.isLoggedIn) {
            api.get('/impersonation')
                .then((response) => {
                    this.impersonated = response.data;
                    return response;
                })
                .catch((error) => {
                    this.impersonated = false;
                    return Promise.reject(error);
                });
        }
    },

    data: () => ({
        impersonated: false
    }),

    computed: {
        ...mapGetters('user', {
            isLoggedIn: 'isLoggedIn',
            user: 'get',
            getName: 'getName'
        })
    },

    methods: {
        reverseImpersonate() {
            window.location = '/stop-impersonation';
        }
    }
};
</script>

<template>
    <div
        v-if="impersonated && getName"
        class="fixed top-28 right-[-350px] h-[135px] hover:right-0 w-[400px] bg-white shadow-md p-4 rounded-r-md z-50 border-t border-b border-r-8 border-red-500 transition-all ease-in-out"
    >
        <div class="relative">
            <p>Sie sind Impersonisiert als</p>
            <strong>
                {{ getName }}
            </strong>
            <br />
            <button @click="reverseImpersonate" class="underline font-semibold">Impersonierung Rückgängig machen</button>
            <p class="transform rotate-90 absolute -top-2 -right-2 text-xs w-0 h-0 font-semibold">Impersonierung</p>
        </div>
    </div>
</template>
